export default __webpack_public_path__ + "static/media/soccer_white.20e4ba14.svg";